import React, { useCallback } from 'react';
import { useDispatch, useSelector } from 'react-redux';
import BaseAsset from './Layouts/asset';
import { modalState, toggleModal } from 'reducers/ui';
import { getUserAssignedDepartmentList, getUserRoles } from 'reducers/users';
import { filters } from './filters';
import { columns } from './columns';
import { assetNS } from './';
import assetForm from './form';
import assetDetails from './assetDetails';
import { ManagerAndAbove, userHasRole } from 'utils/helper/roles';
const Assets = () => {
  //-----------------------selectors-----------------------
  const assetModal = useSelector(state => modalState(state));
  const userRoles = useSelector(state => getUserRoles(state));
  const userAssignedDepartments = useSelector(state =>
    getUserAssignedDepartmentList(state),
  );
  //-----------------------Actions-------------------------
  const dispatch = useDispatch();

  const dispatchToggleModal = useCallback(
    () => dispatch(toggleModal(assetNS)),
    [dispatch],
  );
  const loading = useSelector(state => state.ui.loading);
  return (
    <BaseAsset
      toggleModal={dispatchToggleModal}
      onEdit={assetModal[assetNS]}
      filtersRequired={true}
      editable={userHasRole({
        userRoles: userRoles,
        requiredRoles: ManagerAndAbove,
      })}
      userAssignedDepartments={userAssignedDepartments}
      filters={filters}
      filterKey="category"
      FormComponent={assetForm}
      details={assetDetails}
      columns={columns}
      loading={loading}
    />
  );
};

export default Assets;
